import React from 'react';
import { TextInput, View } from 'react-native';

import { Icon } from 'reactor/components';

import { Consumer } from 'context';
import styles from './Finder.style';

export default () => (
  <Consumer>
    { ({ l10n = {}, onSearch }) => (
      <View style={styles.container}>
        <View style={styles.finder}>
          <TextInput
            autoCorrect={false}
            autoCapitalize="none"
            onChangeText={onSearch}
            placeholder={`${l10n.SEARCH}...`}
            placeholderTextColor="rgba(0,0,0,0.33)"
            underlineColorAndroid="transparent"
            style={styles.input}
          />
          <Icon value="search" style={styles.icon} />
        </View>
      </View>
    )}
  </Consumer>
);
